import { Table, Modal, Typography, Popconfirm } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Stack, useMediaQuery } from "@mui/material";

import ReceivePayment from "./ReceivePayment";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const ReceivedPaymentListing = ({ jrData, fetchJrData }) => {
  console.log(jrData);
  const [receivePaymentModal, setReceivePaymentModal] = useState(false);
  const [manualPaymentDetails, setManualPaymentDetails] = useState([]);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [totalVendorCharge, setTotalVendorCharge] = useState(0);

  const [editingAccount, setEditingAccount] = useState(null);
  const isMobile = useMediaQuery("(max-width: 600px)");
  // Function to fetch receivable accounts
  const fetchManualPaymentDetails = () => {
    axios
      .post("/manualPayment/manualPaymentDetails", { JobId: jrData.job_id })
      .then(({ data }) => {
        setManualPaymentDetails(data.manualPaymentDetails);
        setTimeout(() => {
          checkAndUpdateJobStatus(data.manualPaymentDetails); // Pass fresh data directly
        }, 0);
      });
  };

  const fetchInvoiceDetails = () => {
    axios
      .post("/manualPayment/vendorInvoiceDetails", { JobId: jrData.job_id })
      .then(({ data }) => {
        console.log(data.invoiceDetails);
        setInvoiceDetails(data.invoiceDetails);

        const invoice = data.invoiceDetails?.[0];
        const total = invoice?.total_vendor_charge ?? 0;
        setTotalVendorCharge(total);

        axios
          .post("/manualPayment/manualPaymentDetails", { JobId: jrData.job_id })
          .then(({ data: paymentData }) => {
            setManualPaymentDetails(paymentData.manualPaymentDetails);
            if (jrData.payment_done !== 1) {
              checkAndUpdateJobStatus(paymentData.manualPaymentDetails, total);
            }
          });
      })
      .catch((error) => {
        console.error("Failed to fetch invoice or payment details:", error);
      });
  };

  const checkAndUpdateJobStatus = (payments, totalVendorCharge) => {
    const totalReceived = payments.reduce(
      (sum, p) => sum + parseFloat(p.received_amount || 0),
      0
    );
    console.log(totalReceived, totalVendorCharge);

    if (totalReceived >= parseFloat(totalVendorCharge)) {
      axios
        .post("/manualPayment/updateJobToComplete", {
          JobId: jrData.job_id,
        })
        .then(() => {
          fetchJrData();
          console.log("Job status updated to Completed");
        })
        .catch((err) => {
          console.error("Failed to update job status:", err);
        });
    }
  };

  // Fetch data on mount
  useEffect(() => {
    fetchInvoiceDetails(); // This will also trigger check/update
  }, []);

  const handleCloseModal = () => {
    setReceivePaymentModal(false);
    // setEditingAccount(null); // This resets form data
  };

  // Handle delete action
  const handleDelete = (id) => {
    axios
      .post(`/manualPayment/deleteManualPayment/${id}`)
      .then(() => {
        fetchManualPaymentDetails(); // Refresh list after deletion
      })
      .catch((err) => console.error("Error deleting:", err));
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "payment_date",
      key: "payment_date",
    },
    {
      title: "Amount",
      dataIndex: "received_amount",
      key: "received_amount",
      render: (amount) => {
        const num = parseFloat(amount);
        return isNaN(num) ? "$0.00" : `$${num.toFixed(2)}`;
      },
    },
    {
      title: "Remaining Balance",
      key: "remaining_amount",
      render: (_, record) => {
        // Get all payments for this job
        const jobPayments = manualPaymentDetails.filter(
          (r) => r.job_id === record.job_id
        );

        //  Find index of current payment
        const currentIndex = jobPayments.findIndex(
          (p) => p.received_payment_id === record.received_payment_id
        );
        // Find invoice for the job
        const invoice = invoiceDetails.find(
          (inv) => inv.job_id === record.job_id
        );
        const total = parseFloat(invoice?.total_vendor_charge || 0);
        // Sum only previous payments (up to this one)
        const receivedSoFar = jobPayments
          .slice(0, currentIndex + 1)
          .reduce((sum, p) => sum + parseFloat(p.received_amount || 0), 0);

        // 5. Calculate remaining
        const remaining = (total - receivedSoFar).toFixed(2);

        return `$${remaining}`;
      },
    },
    {
      title: "JR ID",
      dataIndex: "job_id",
      key: "job_id",
    },
    {
      title: "Bank Account",
      dataIndex: "received_bank_account",
      key: "received_bank_account",
      render: (text) => `****${text}`,
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
    },

    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Stack direction="row" spacing={1}>
          {isMobile ? (
            <EditOutlined
              onClick={() => {
                setEditingAccount(record); // Pass record to form
                setReceivePaymentModal(true);
              }}
            />
          ) : (
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="button"
              onClick={() => {
                setEditingAccount(record); // Pass record to form
                setReceivePaymentModal(true);
              }}
            >
              Edit
            </Button>
          )}

          {/* Delete Button */}
          <Popconfirm
            title="Are you sure to delete?"
            onConfirm={() => handleDelete(record.received_payment_id)}
            okText="Yes"
            cancelText="No"
          >
            {isMobile ? (
              <DeleteOutlined />
            ) : (
              <Button
                variant="contained"
                color="primary"
                size="small"
                type="button"
                danger
              >
                Delete
              </Button>
            )}
          </Popconfirm>
        </Stack>
      ),
    },
  ];

  return (
    <div>
      <Stack direction={"row"} spacing={1} alignItems={"center"}>
        <Typography sx={{ fontWeight: "bold" }}>
          Received Payment List:{" "}
        </Typography>

        <Button
          size="small"
          type="button"
          variant="contained"
          color="primary"
          onClick={(e) => {
            setReceivePaymentModal(true);
          }}
        >
          Add
        </Button>
      </Stack>

      <Table
        style={{ marginTop: 2 }}
        columns={columns.filter(
          (col) =>
            !isMobile || !["received_bank_account", "notes"].includes(col.key)
        )}
        rowKey="received_payment_id"
        dataSource={manualPaymentDetails}
        pagination={false}
        bordered
      />
      <Modal
        destroyOnClose={true}
        width="400px"
        title="Payment Details"
        open={receivePaymentModal}
        onCancel={handleCloseModal}
        footer={false}
      >
        <ReceivePayment
          jrData={jrData}
          setReceivePaymentModal={setReceivePaymentModal}
          editingAccount={editingAccount}
          fetchManualPaymentDetails={fetchManualPaymentDetails}
        />
      </Modal>
    </div>
  );
};

export default ReceivedPaymentListing;
